import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "./utility";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from "moment";


export default function Table({ title, data, columns, flag }) {
  const tableData = {
    columns,
    data,
  };
  const [pending, setPending] = useState(true)
  const [rows, setRows] = React.useState([]);

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setRows(data)
      setPending(false)
    }
  }, [data])

  return (
    <div className="ibox-content">
      <DataTableExtensions
        print
        export
        exportHeaders
        fileName={`Feasti-${title}-${moment().format("DD-MM-YYYY")}`}
        {...tableData}>
        <DataTable
          title={title}
          columns={columns}
          data={rows}
          highlightOnHover
          progressPending={pending}
          progressComponent={() => <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
            Loading...
          </div>}
          noHeader
          dense={flag}
          customStyles={customStyles}
          pagination
          paginationDefaultPage={1}
          paginationRowsPerPageOptions={[25, 50, 100, 200]}
          paginationPerPage={25}
        />
      </DataTableExtensions>
    </div>
  );
}
